import { _ as _sfc_main } from "../../MPasswordField.vue_vue_type_script_lang-baf1023a.mjs";
import { resolveComponent, openBlock, createBlock, mergeProps, withCtx, createVNode, createTextVNode, createCommentVNode, toDisplayString } from "vue";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-3194dc60.mjs";
import "../../_VTextField-74fe2c1a.mjs";
import "../../index-dbde2d54.mjs";
import "../../_density-8094aebe.mjs";
import "../../_proxiedModel-031e293c.mjs";
import "../../flow-501bd5ba.mjs";
import "../../_commonjsHelpers-ca272635.mjs";
import "../../index-64135f7d.mjs";
import "../../index-13be80af.mjs";
import "../../index-fd2245c5.mjs";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_text_field = resolveComponent("v-text-field");
  return openBlock(), createBlock(_component_v_text_field, mergeProps({ ref: "field" }, _ctx.updatedProps, {
    class: "m-password-field",
    modelValue: _ctx.localValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.localValue = $event),
    onClick: [_ctx.onClick, _ctx.onClick],
    "onClick:control": _ctx.onClickControl,
    "onMousedown:control": _ctx.onMousedownControl,
    "onUpdate:focused": _ctx.onUpdateFocused
  }), {
    "append-inner": withCtx(() => [
      _ctx.showGenerator ? (openBlock(), createBlock(_component_v_btn, {
        key: 0,
        icon: "",
        onClick: _ctx.onGeneratePassword,
        variant: "plain",
        density: "compact"
      }, {
        default: withCtx(() => [
          createVNode(_component_v_icon, null, {
            default: withCtx(() => [
              createTextVNode("mdi-form-textbox-password")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])) : createCommentVNode("", true),
      createVNode(_component_v_btn, {
        icon: "",
        onClick: _ctx.togglePasswordFieldType,
        variant: "plain",
        density: "compact"
      }, {
        default: withCtx(() => [
          createVNode(_component_v_icon, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.passwordFieldTypeIcon), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 16, ["modelValue", "onClick", "onClick:control", "onMousedown:control", "onUpdate:focused"]);
}
const MPasswordField = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MPasswordField.vue"]]);
export {
  MPasswordField as default
};
//# sourceMappingURL=MPasswordField.es.js.map
